module.exports = __webpack_public_path__ + "static/media/saag.68def832.png";